import { Body2 } from '../../../ui-kit'
import { marginTop, textAlignCenter } from '../../../ui-kit/utils'

export const Info = ({ info }: { readonly info: string | null }) =>
  !!info ? (
    <div css={marginTop(16)}>
      <Body2 css={textAlignCenter}>{info}</Body2>
    </div>
  ) : null
